import { render, staticRenderFns } from "./packageInfo.vue?vue&type=template&id=313467a2&scoped=true&"
import script from "./packageInfo.vue?vue&type=script&lang=js&"
export * from "./packageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313467a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313467a2')) {
      api.createRecord('313467a2', component.options)
    } else {
      api.reload('313467a2', component.options)
    }
    module.hot.accept("./packageInfo.vue?vue&type=template&id=313467a2&scoped=true&", function () {
      api.rerender('313467a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/packageInfo.vue"
export default component.exports